import { InjectionToken, signal } from '@angular/core';
import { resolveLocale } from '@shared/models/auth';

/**
 * The Active Formatting Locale as a reactive signal — the single interface every
 * formatter reads via `inject(ACTIVE_LOCALE)()` (pipes, datepicker, calendars).
 *
 * The factory default is a constant signal at the product fallback (`de-DE`), so
 * a consumer rendered without a provider (a story, a bare test) formats sensibly
 * rather than throwing or leaking Angular's `en-US`. Every app overrides it at
 * its composition root with `{ provide: ACTIVE_LOCALE, useFactory: () =>
 * injectActiveLocale() }` (see `@tvd/ui/locale`), yielding one shared reactive
 * signal per app. This layer stays free of auth/translate: it imports only the
 * pure `Locale` / `resolveLocale` from `@shared/models/auth`.
 */
export const ACTIVE_LOCALE = new InjectionToken('tvd.active-locale', {
  providedIn: 'root',
  factory: () => signal(resolveLocale('de-DE')),
});
